<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner9.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li @click="backPage('-1')">{{ name }}</li>
                <li>></li>
                <li>{{ newsDetail.title }}</li>
            </ul>
            <h3 class="tab_title" style="margin-bottom: 40px;">{{ newsDetail.title }}</h3>
            <div class="editor" v-html="newsDetail.content"></div>
        </div>

    </div>
</template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import { getNewsDetail } from '../../api/index'
export default {
    data() {
        return {
            newsDetail: {},
            name:'新闻资讯'
        }
    },
    mounted() {
        getNewsDetail(this.$route.query.id).then(res => {
            console.log(res);
            this.newsDetail = res.data
            this.name = this.newsDetail.category == 3?'技术文章':'新闻资讯'
        })
    },
    methods:{
        backPage(page){
            if(page == '-1'){
                this.$router.go(-1)
            }else{
                this.$router.push(page)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/news/detail.vue